import type { LabeledStat } from '@/components/common/StatCardGrid';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import { EXPENSE_HEADS } from '../constants/zonalStatement.constants';
import type { ExpenseStatementTotals, SpecimenStatement } from '../types/zonalStatement.types';

export function getExpenseStatCards(totals: ExpenseStatementTotals | undefined): LabeledStat[] {
  return [
    ...EXPENSE_HEADS.map(
      (head): LabeledStat => ({
        key: head.key,
        label: head.label,
        value: totals?.[head.key],
        unit: TAKA_SYMBOL,
      }),
    ),
    {
      key: 'total',
      label: 'Total',
      value: totals?.total,
      unit: TAKA_SYMBOL,
    },
  ];
}

export function getSpecimenStatCards(statement: SpecimenStatement | undefined): LabeledStat[] {
  return [
    {
      key: 'specimens',
      label: 'Specimens',
      value: statement?.items.length,
    },
    {
      key: 'receivedQty',
      label: 'Received Qty',
      value: statement?.totals.receivedQty,
    },
    {
      key: 'distributedQty',
      label: 'Distributed Qty',
      value: statement?.totals.qty,
    },
    {
      key: 'inHandQty',
      label: 'In Hand Qty',
      value: statement?.totals.inHandQty,
    },
    {
      key: 'inHandAmount',
      label: 'In Hand Amount',
      value: statement?.totals.inHandAmount,
      unit: TAKA_SYMBOL,
    },
  ];
}
